"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputComponent = void 0;
var _PopupModalComponent = require("./PopupModalComponent");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _PriceComponent = _interopRequireDefault(require("./PriceComponent"));
var _FeatureTextComponent = _interopRequireDefault(require("./FeatureTextComponent"));
var _InputSwitchComponent = _interopRequireDefault(require("./InputSwitchComponent"));
var _storeProvider = require("./../util/storeProvider");
var _InputComponent = require("./InputComponent.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
class InputComponent extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalShown: false
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(value) {
    var {
      instancePath,
      layoutProperties: {
        display
      }
    } = this.props;
    const {
      hasModal,
      showModal,
      modalShown
    } = this.state;
    if (display === 'integer') {
      instancePath = instancePath.replace('options', 'quantity');
    }
    if (!modalShown && !showModal && hasModal) {
      this.setState({
        showModal: true,
        modalShown: true
      });
    } else {
      this.context.store.updateInstance(instancePath, value);
    }
  }
  componentDidMount() {
    const {
      enumVal,
      content,
      layoutProperties: {
        modal = []
      }
    } = this.props;
    this.setState({
      hasModal: content['modal-text'] && modal.includes(enumVal)
    });
  }
  render() {
    const {
      content,
      enumVal,
      price,
      layoutProperties: {
        display,
        priceDisplay = 'default'
      },
      quantifier,
      termType
    } = this.props;
    const {
      hasModal
    } = this.state;
    const isMobile = this.context.isBrowser && ['mobile'].includes(this.context.breakpoint);
    const indentClass = !['domainSearch', 'noinput'].includes(display) ? 'input-indent' : '';
    let col1Class = 'text-default col-xs-12';
    let col2Class = `${isMobile ? indentClass : 'text-right no-padding'} col-xs-12`;
    if (priceDisplay !== 'removed') {
      col1Class += ' col-sm-8 col-md-8';
      col2Class += ' col-sm-4 col-md-4';
    }
    const featureText = display !== 'domainSearch' ? /*#__PURE__*/React.createElement(_FeatureTextComponent.default, {
      indentClass: indentClass,
      content: content,
      isMobile: isMobile
    }) : null;
    const priceComponent = /*#__PURE__*/React.createElement(_PriceComponent.default, {
      enumVal: enumVal,
      priceDisplay: priceDisplay,
      priceText: content['price-text'],
      priceText2: content['price-text-2'],
      includeState: [{
        path: 'data.layout.content'
      }],
      price: price,
      quantifier: quantifier,
      termType: termType
    });
    return /*#__PURE__*/React.createElement(_InputComponent.Styles, {
      className: "bd-b-1 mb-2 pb-2 input-component"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row mr-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: col1Class
    }, /*#__PURE__*/React.createElement(_InputSwitchComponent.default, _extends({
      handleChange: this.handleChange
    }, this.props)), !isMobile && featureText), priceComponent && /*#__PURE__*/React.createElement("div", {
      className: col2Class
    }, priceComponent)), isMobile && featureText, this.state.showModal && hasModal && /*#__PURE__*/React.createElement(_PopupModalComponent.PopupModalComponent, {
      cancelFunc: () => this.setState({
        showModal: false
      }),
      confirmFunc: () => {
        this.setState({
          showModal: false
        }, () => this.handleChange());
      },
      title: content['modal-title'],
      text: content['modal-text'],
      cancelText: content['modal-button-cancel'],
      confirmText: content['modal-button-confirm'],
      type: content['modal-type'],
      show: this.state.showModal
    }));
  }
}
exports.InputComponent = InputComponent;
InputComponent.propTypes = {
  content: _propTypes.default.object.isRequired,
  selectedVal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number]),
  instancePath: _propTypes.default.string.isRequired,
  layoutProperties: _propTypes.default.object,
  enumVal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number]),
  price: _propTypes.default.object,
  quantifier: _propTypes.default.string,
  termType: _propTypes.default.string
};
var _default = exports.default = (0, _storeProvider.provideContext)(InputComponent);